import {
  AutoComplete,
  Button,
  Card,
  Checkbox,
  Col,
  Divider,
  Input,
  InputNumber,
  message,
  Row,
  Spin,
  Upload
} from 'antd';
import { useModal } from '@root/core/hooks/useModal';
import InqueryHistory from '../../components/InqueryHistory';
import FromToInforComponent, { fromToInfo } from '../../components/FromToInfor';
import { useActions } from '@root/core/hooks/useActions';
import { useEffect, useState } from 'react';
import { useTypedSelector } from '@root/core/hooks/useTypedSelector';
import {
  billingInquiry,
  infor,
  inquiryInboundInfo
} from '@root/state/reducers/Settlement/settlementReducer';
import { UploadFile, UploadProps } from 'antd/lib/upload/interface';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import settlementService from '../../Services/settlementService';
import { useHistory } from 'react-router-dom';

const InfoCreate = () => {
  // state
  const [search, getSeach] = useState<string>('');
  const [createLoading, setCreateLoading] = useState(false);
  const [showCustomerInfo, getShowCustomerInfo] = useState<infor>();
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [dateFrom, setDateFrom] = useState<string>();
  const [dateTo, setDateTo] = useState<string>();
  const [billingAmount, setBillingAmount] = useState<number>();
  const [checkedAgree, setCheckedAgree] = useState<boolean>(false);

  const { show, RenderModal } = useModal();
  const history = useHistory();

  const confirmBilling = () => {
    show();
  };

  const { getCustomerLists, getInquiryInboundInfo, postCreateBillingInquiry } =
    useActions();

  const { customerLists } = useTypedSelector(
    (state) => state.customerInfoListReducer
  );

  const { info, loading } = useTypedSelector(
    (state) => state.inquiryInboundInfoReducer
  );
  const { loadingCreate, bodyBillingInquiry } = useTypedSelector(
    (state) => state.createBillingInquiryReducer
  );
  const onSelect = (selectValue: number) => {
    getShowCustomerInfo(
      customerLists?.find((customerInfo) => customerInfo.id === selectValue)
    );
  };

  const onSearchCustomer = async (searchValue: string) => {
    getSeach(searchValue);
    if (dateFrom && dateTo) {
      getInquiryInboundInfo(idCustomer, dateFrom, dateTo);
    }
  };

  const options = customerLists?.map((customerList: infor) => {
    return {
      key: customerList.id,
      value: customerList.name,
      label: (
        <div
          key={customerList.id}
          onClick={() => {
            onSelect(customerList.id);
          }}
        >
          {customerList.name}
        </div>
      )
    };
  });

  useEffect(() => {
    getCustomerLists(search);
  }, []);

  // get inquiry and inbound
  const idCustomer = showCustomerInfo ? showCustomerInfo?.id : NaN;

  // get date
  const getDate = (startDate?: string, endDate?: string) => {
    if (idCustomer) {
      getInquiryInboundInfo(
        idCustomer,
        startDate ? startDate : '',
        endDate ? endDate : ''
      );
    }

    setDateFrom(startDate);
    setDateTo(endDate);
  };

  // final confirmation info
  const finalConfirmationInfo: fromToInfo = {
    warehouse: info?.warehouse,
    seller: showCustomerInfo
      ? showCustomerInfo
      : {
          id: NaN,
          name: '',
          country: '',
          countryCode: '',
          phoneNumber: '',
          detailAddress: '',
          email: ''
        }
  };

  // Inquiry history
  const inquiryHistory: inquiryInboundInfo = {
    numberDelivered: info?.numberDelivered ? info?.numberDelivered : 0,
    numberDisposal: info?.numberDisposal ? info?.numberDisposal : 0,
    numberProductTypes: info?.numberProductTypes ? info?.numberProductTypes : 0,
    numberReturn: info?.numberReturn ? info?.numberReturn : 0,
    orderCounts: info?.orderCounts ? info?.orderCounts : 0,
    warehouse: info?.warehouse
  };

  const validateFileType = (
    { type }: UploadFile,
    allowedTypes: string[] = ['image/jpeg', 'image/png', 'application/pdf']
  ) => {
    return allowedTypes.includes(type!);
  };

  const props: UploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    onChange: ({ fileList: newFileList }) => {
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      const isAllowedType = validateFileType(file);
      if (!isAllowedType) {
        message.error(`${file.name} is not JPEG file`);
        return false;
      }
      setFileList((prev) => {
        if (prev.length < 1) {
          return [...prev, file];
        }
        return prev;
      });
      setFileList([...fileList, file]);
      return false;
    },
    fileList
  };

  // agree check point
  const agreeHandle = (e: CheckboxChangeEvent) => {
    setCheckedAgree(e.target.checked);
  };

  // billing amount
  const billingAmountHandle = (e: number) => {
    setBillingAmount(e);
  };

  //validate create billing
  const ableCreate =
    !!checkedAgree &&
    !!search &&
    !!dateFrom &&
    !!dateTo &&
    fileList.length === 1 &&
    !!billingAmount
      ? true
      : false;

  // upload file billing
  const bodyCreateBilling: billingInquiry = {
    sellerId: idCustomer,
    periodStart: dateFrom ? dateFrom : '',
    periodEnd: dateTo ? dateTo : '',
    numberDelivered: info?.numberDelivered ? info?.numberDelivered : 0,
    numberDisposal: info?.numberDisposal ? info?.numberDisposal : 0,
    numberProductTypes: info?.numberProductTypes ? info?.numberProductTypes : 0,
    numberReturn: info?.numberReturn ? info?.numberReturn : 0,
    orderCounts: info?.orderCounts ? info?.orderCounts : 0,
    billingAmount: billingAmount ? billingAmount : 0,
    billingInquiryFileId: NaN
  };
  const postUploadFileBilling = async () => {
    try {
      const formData = new FormData();
      formData.append('file', fileList[0]?.originFileObj as any);

      const uploadFile = await settlementService.postUploadBillingInquiry(
        formData
      );
      bodyCreateBilling.billingInquiryFileId =
        uploadFile?.data?.billingInquiry?.id;
    } catch (error: any) {
      const { data } = error?.response;
      if (data && data?.message) {
        message.error(data?.message[0]);
      }
    }
  };
  const sendHandle = async () => {
    setCreateLoading(true);
    try {
      await postUploadFileBilling();
      const createBilling = await settlementService.postCreateBillingInquiry(
        bodyCreateBilling
      );
      if (createBilling.message === 'success') {
        message.success('Create billing inquiry successfully');
        history.push('/admin/billingInquiry');
      }
    } catch (error: any) {
      message.error(error?.response?.data?.message[0]);
      setCreateLoading(false);
    }
    setCreateLoading(false);
  };

  return (
    <div>
      <div className="wrapInfoBill">
        <Row gutter={40}>
          <Col span={10}>
            <div className="infoSearch">
              <AutoComplete
                options={options}
                dropdownMatchSelectWidth={350}
                style={{ width: '100%' }}
                onChange={onSearchCustomer}
                filterOption={(inputValue, option) =>
                  option!.value
                    .toUpperCase()
                    .indexOf(inputValue.toUpperCase()) !== -1
                }
              >
                <Input.Search
                  size="large"
                  placeholder="Search Customer..."
                  className="customer_info"
                />
              </AutoComplete>
              {search && showCustomerInfo && (
                <div style={{ marginTop: '20px' }}>
                  <p>
                    <b> {showCustomerInfo?.name}</b>
                    <span style={{ marginLeft: 50 }}>
                      {showCustomerInfo?.country}
                    </span>
                  </p>
                  <p>
                    <b>Tel</b>
                    <span style={{ marginLeft: 20 }}>
                      <span>{showCustomerInfo?.countryCode}</span>
                      {showCustomerInfo?.phoneNumber}
                    </span>
                  </p>
                  <p>
                    <b>Email</b>
                    <span style={{ marginLeft: 20 }}>
                      {showCustomerInfo?.email}
                    </span>
                  </p>
                  <p className="address">
                    #{showCustomerInfo?.detailAddress}
                    <br /> {showCustomerInfo?.country}
                  </p>
                </div>
              )}
              {!search && (
                <div style={{ marginTop: '20px' }}>
                  <p>
                    <b>Customer Name</b>
                  </p>
                  <p>
                    <b>Tel</b>
                  </p>
                  <p>
                    <b>Email</b>
                  </p>
                  <p>
                    <b>Address</b>{' '}
                  </p>
                </div>
              )}
            </div>
          </Col>
          <Col span={14}>
            <div className="infoCheckPoint">
              <h2>Checkpoint</h2>
              <ul>
                <li>
                  We will charge a 12% commission for this cost for the reason
                  using the service.(Variable)
                </li>
                <li>
                  Please enter the amount considering the service commission.
                </li>
                <li>
                  'Customer discount' will be deducted from Busk service
                  commission.
                </li>
              </ul>
              <p className="checkboxPoint">
                <Checkbox onChange={agreeHandle}>
                  I agree to the cost related information
                </Checkbox>
              </p>
            </div>
          </Col>
        </Row>
      </div>
      <Spin spinning={createLoading || loadingCreate}>
        <div className="inquiry_history">
          <Card style={{ padding: '40px 10px' }}>
            <Spin spinning={loading}>
              <InqueryHistory
                idCustomer={idCustomer}
                inquiryHistory={inquiryHistory}
                getDate={getDate}
              />
              <Row>
                <Col span={6}>
                  <h2>Enter the billing amount</h2>
                </Col>
                <Col span={14}>
                  <Divider dashed style={{ borderWidth: '2px 0 0' }} />
                </Col>
                <Col span={5} align="right">
                  <div style={{ marginBottom: '0' }} className="payment">
                    US$
                    <span style={{ marginLeft: '20px', width: '100%' }}>
                      <InputNumber
                        decimalSeparator={','}
                        placeholder={'0'}
                        formatter={(value) => {
                          const splitted = String(value).split('.');
                          let newValue = String(value);
                          if (String(value).includes('.')) {
                            newValue =
                              splitted[0] + '.' + splitted[1].slice(0, 2);
                          }
                          return `${newValue}`.replace(
                            /\B(?=(\d{3})+(?!\d))/g,
                            ','
                          );
                        }}
                        parser={(value) => {
                          const splitted = String(value).split('.');
                          if (String(value).includes('.')) {
                            value = splitted[0] + '.' + splitted[1].slice(0, 2);
                          }
                          return parseFloat(value!.replace(/\$\s?|(,*)/g, ''));
                        }}
                        className="InputNumberNoArrow"
                        style={{ width: '100%' }}
                        onChange={billingAmountHandle}
                      />
                    </span>
                  </div>
                </Col>
                <Col span={8} className="billingAmount">
                  <p>Please enter the billing amount </p>
                </Col>
              </Row>
              <Row>
                <Col
                  span={24}
                  align="right"
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                >
                  <Upload
                    {...props}
                    multiple
                    fileList={fileList}
                    accept=".png, .jpg, .pdf, .jpeg"
                    maxCount={1}
                    showUploadList={{
                      showPreviewIcon: false
                    }}
                  >
                    <Button
                      className="upload_inquery"
                      disabled={fileList.length >= 1}
                    >
                      Upload Billing Inquiry
                    </Button>
                  </Upload>
                  <Button
                    className="confirm"
                    onClick={confirmBilling}
                    disabled={!ableCreate}
                  >
                    Confirm
                  </Button>
                </Col>
              </Row>
            </Spin>
          </Card>
        </div>
      </Spin>
      <div id="modal-root" className="ant-modal">
        <RenderModal width={1400} handleOk={sendHandle}>
          <div
            style={{ width: '100%', padding: '20px' }}
            className="inquiry_history"
          >
            <div
              style={{
                display: 'flex',
                marginBottom: '30px'
              }}
            >
              <h2 style={{ width: '50%', padding: '10px', fontSize: '25px' }}>
                Final Confirmation
              </h2>

              <FromToInforComponent fromToInfo={finalConfirmationInfo} />
            </div>
            <InqueryHistory
              idCustomer={idCustomer}
              inquiryHistory={inquiryHistory}
              getDate={getDate}
              dateFrom={dateFrom}
              dateTo={dateTo}
              confirm={true}
            />
            <Row>
              <Col span={6}>
                <h2 style={{ marginBottom: '0', fontSize: '30px' }}>
                  Total Payment
                </h2>
              </Col>
              <Col span={19} align="right">
                <p
                  style={{
                    marginBottom: '0',
                    fontSize: '25px',
                    fontWeight: 'bolder'
                  }}
                >
                  US$
                  <span style={{ marginLeft: '5px' }}>
                    {billingAmount
                      ? billingAmount.toLocaleString('en-US', {
                          minimumFractionDigits: 2
                        })
                      : 0}
                  </span>
                </p>
              </Col>
            </Row>
          </div>
        </RenderModal>
      </div>
    </div>
  );
};

export default InfoCreate;
